'use server'

import { apiRequest, ApiResponse } from '../request'

export interface BlockedIp {
    id: number
    ipOrCidr: string
    reason: string | null
    organizationId: number | null
    createdById: number | null
    active: boolean
    expiresAt: string | null
    createdAt: string
    updatedAt: string
}

const BASE = 'security/blocked-ips'

export async function getBlockedIps(): Promise<ApiResponse<BlockedIp[]>> {
    return apiRequest<BlockedIp[]>(BASE, {})
}

export async function addBlockedIp(data: {
    ipOrCidr: string
    reason?: string
    scope?: 'GLOBAL' | 'ORG'
    expiresAt?: string
}): Promise<ApiResponse<BlockedIp>> {
    return apiRequest<BlockedIp>(BASE, { data }, 'post')
}

export async function removeBlockedIp(
    id: number,
): Promise<ApiResponse<{ removed: boolean }>> {
    return apiRequest(`${BASE}/${id}`, {}, 'delete')
}
